import {
  NotificationDefinitionRequestQuery,
  UserNotificationSearchRequestQuery,
  UserNotificationPreferenceSearchRequestQuery,
  NotificationsSearchRequestQuery,
} from '@lio/api-types';
import { userQueryKey } from '@services/user/keys';

export const NotificationDefinitionKeys = {
  search: ['notification-definition'] as const,
  searchParams: (params: NotificationDefinitionRequestQuery) => [...NotificationDefinitionKeys.search, params] as const,
};

export const NotificationKeys = {
  summary: ['notification-summary'] as const,
  userNotifications: ['user-notification'] as const,
  preferences: ['notification-preferences'] as const,
  searchUserNotifications: (params: UserNotificationSearchRequestQuery) =>
    [...NotificationKeys.userNotifications, params] as const,
  searchPreferences: (userId: string, params?: UserNotificationPreferenceSearchRequestQuery) =>
    [...NotificationKeys.preferences, ...userQueryKey.getWithParams(userId), params && params] as const,
  notifications: ['notifications'] as const,
  searchNotifications: (params: NotificationsSearchRequestQuery) =>
    [...NotificationKeys.notifications, params] as const,
  notificationById: (id?: string) => ['notification', id] as const,
};
